export default __webpack_public_path__ + "static/college-audition-guide-preview-1-bba16a0b6996584f7e8d337656a1c41a.jpg";